export default __webpack_public_path__ + "static/media/law changes woman on pc.b5a558ae.png";